import type { ExcalidrawFontFaceDescriptor } from "../Fonts";

// Georgia - system font, no external loading needed
export const GeorgiaFontFaces: ExcalidrawFontFaceDescriptor[] = [];